import AssetService from '@ane/core/lib/services/AssetService';
import { init } from './init';
import Logger from '@ane/core/lib/services/logging/Logger';

export const setPath = async (bundle: string, loginUserAndGetTreatmentAssignment: boolean) => {
  Logger.trackMetric({
    name: `PLT:Bootstrap:${bundle}:setPath`,
    average: performance.now(),
    properties: {
      url: document.location.href,
    },
  });
  // initialize so that we can ensure that we have the correct assetUrl including any custom CDN path
  await init(bundle, loginUserAndGetTreatmentAssignment);
  // in order for webpack to load chunks from a dynamic path such as a CDN
  // we need to assign the CDN url to the webpack global
  __webpack_public_path__ = AssetService.assetUrl;
  Logger.trackMetric({
    name: `PLT:Bootstrap:${bundle}:setPath:after`,
    average: performance.now(),
    properties: {
      url: document.location.href,
    },
  });
};
